var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSmartbear = function SvgSmartbear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 101.2 57.4"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ff730b",
    d: "M58.6 48.3h-16l-2.8 9h21.5zm42.6 9-8.3-25.9 5.4-16.7L78.3.1 64.1 10.3h-27L23 0 3 14.6l5.4 16.8L0 57.3h26.3l-2-6.5 26.3-19.2 26.3 19.3-2 6.5z"
  })));
};
export default SvgSmartbear;